import styled from "styled-components";
import {styledByTheme} from "../../../themes/architecture/styled-by-theme";

export const MobileMenuItemContainerDefaultBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    align-content: center;
    margin: 0rem 1.2rem;
    background-color: ${({theme}) => theme.colors.background};

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin: 0rem 1.6rem;
    }
    
    
    position: relative;
    margin-top: 1px;
    &:before {
        content: "";
        display: block;
        position: absolute;
        top: -2px;
        left: 0;
        width: 100%;

        box-sizing: content-box;
        height: 1px;
        background-color: ${({theme}) => theme.colors.backgroundDark};
        box-shadow: 0px 0.35px 0px 0px ${({theme}) => theme.colors.boxBorderContrast};
        margin-bottom: 1px;
    }

    &:first-child {
        margin-top: 0;
        &::before {
            display: none;
        }
    }

`

export const MobileMenuItemContainerCasino777Box = styled(MobileMenuItemContainerDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        margin: 0 1rem;
        padding: 0 1rem;
    }
    &:before {
        display: none;
    }
`;

export const MobileMenuItemContainerMrGreenBox = styled(MobileMenuItemContainerDefaultBox)`
    background-color:  transparent;
`;

export const MobileMenuItemContainerBox = styledByTheme(MobileMenuItemContainerDefaultBox)
    .forCasino777(MobileMenuItemContainerCasino777Box)
    .forMrGreen(MobileMenuItemContainerMrGreenBox)
    .apply();